import { TrueType } from 'library/ts/utilities/modules/enums/TrueType';
export const isJSON = (value) => {
    value = typeof value !== TrueType.STRING
        ? JSON.stringify(value)
        : value;
    try {
        value = JSON.parse(value);
    }
    catch (error) {
        return false;
    }
    return (typeof value === TrueType.OBJECT && value !== null);
};
export const trueType = (value) => {
    return Object.prototype.toString.call(value).slice(8, -1).toLowerCase();
};
export const isEmpty = (value) => {
    if (value === null || value === undefined)
        return true;
    if (isBoolean(value))
        return false;
    if (isNumber(value))
        return false;
    if (isArray(value))
        return (value.length === 0);
    if (isString(value))
        return (value.trim().length === 0);
    if (isObject(value))
        return (Object.keys(value).length === 0);
    return true;
};
export const isWhitespaceEmptyString = (value) => {
    return value ? !(/\S/.test(value)) : (value === '' || value === null || value === undefined);
};
export const isFunction = (value) => {
    const getType = {};
    return value && getType.toString.call(value) === '[object Function]';
};
export const isBoolean = (value) => {
    return typeof value === TrueType.BOOLEAN;
};
export const isNumber = (value) => {
    if (isNaN(value))
        return false;
    return (typeof value === TrueType.NUMBER && isFinite(value));
};
export const isInteger = (value) => {
    return typeof value === TrueType.NUMBER && isFinite(value) && Number.isInteger(value);
};
export const isDecimal = (value = 0) => {
    if (!isNumber(value))
        return false;
    return (value ^ 0) !== value;
};
export const isString = (value) => {
    return (typeof value === TrueType.STRING || value instanceof String);
};
export const isEmptyString = (value) => {
    return /^ *$/.test(value);
};
export const isBlankObject = (value) => {
    return value !== null && typeof value === TrueType.OBJECT && !Object.getPrototypeOf(value);
};
export const isObject = (value) => {
    if (isUndefined(value) === true)
        return false;
    return (value && typeof value === TrueType.OBJECT);
};
export const isArray = (value) => {
    return Array.isArray(value);
};
export const isIterable = (obj) => {
    if (obj === null || obj === undefined)
        return false;
    return typeof obj[Symbol?.iterator] === TrueType.FUNCTION;
};
export const isBad = (value) => {
    return isNull(value) || isUndefined(value) || isEmpty(value) || isError(value);
};
export const isElement = (node) => {
    return (node !== undefined && node !== null && isFunction(node?.appendChild));
};
export const isJQueryObject = (obj) => {
    return obj !== undefined && (obj?.prevObject !== undefined || obj?.jquery !== undefined);
};
export const isUndefined = (value) => {
    return typeof value === TrueType.UNDEFINED;
};
export const isDefined = (value) => {
    return typeof value !== TrueType.UNDEFINED;
};
export const isDate = (value) => {
    return Object.prototype.toString.call(value) === '[object Date]';
};
export const isError = (value) => {
    return value instanceof Error && typeof value?.message !== TrueType.UNDEFINED;
};
export const isNull = (value) => {
    return value == null;
};
export const isNullOrUndefined = (value) => {
    return value == null || typeof value === TrueType.UNDEFINED;
};
export const isPromise = (value) => {
    return !!value && (typeof value === TrueType.OBJECT || typeof value === TrueType.FUNCTION) && typeof value.then === TrueType.FUNCTION;
};
export const isRegEx = (value) => {
    return value && typeof value === TrueType.OBJECT && value.constructor === RegExp;
};
export const isSymbol = (value) => {
    return typeof value === 'symbol';
};
export const isBase64 = (str) => {
    if (isString(str) === false)
        return false;
    const regex = new RegExp('^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)$');
    if (str.indexOf(' ') !== -1) {
        return false;
    }
    else {
        return (str.match(regex) !== null);
    }
};
export const isXML = (element) => {
    const documentElement = (element ? element.ownerDocument || element : 0).documentElement;
    return documentElement ? documentElement.nodeName !== 'HTML' : false;
};
